module.exports = __webpack_public_path__ + "static/img/1.f464b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newSix/1.png
// module id = uTU6
// module chunks = 0